import { TokenRefreshLink } from 'apollo-link-token-refresh';
import RefreshClient from '@/modules/myStageGraphQL/RefreshClient';
import { MYSTAGE_AUTH_REFRESH } from '@/graphql/mutations/mystageToken';
import { onError } from '@apollo/client/link/error';
import { from } from '@apollo/client/core';
import logger from '@/modules/Logger';
import { 
  getMyStageToken,
  getMyStageRefreshToken,
  saveMyStageLoginCookies
} from '@/modules/myStageGraphQL/AuthCookieManager';

let tokenInvalid = false;

// Refresh Link
const refreshLink = new TokenRefreshLink({
  isTokenValidOrUndefined: async (operation) => {
    return !tokenInvalid && (!!getMyStageToken() || operation.getContext().authRequired === false);
  },
  fetchAccessToken: () => {
    if (!getMyStageRefreshToken()) {
      logger.error(`[MYSTAGE][AUTH] Missing MyStage token and refresh token`, {
          operation: "mystage_refresh_token",
          mystage_token: getMyStageToken()
      });
      throw new Error('Missing MyStage token and refresh token');
    }

    return RefreshClient.mutate({
      mutation: MYSTAGE_AUTH_REFRESH,
    });
  },
  handleResponse: () => async (response) => {
    const data = response?.data?.refreshAuthToken;
    saveMyStageLoginCookies(data || {});

    return  {
      access_token: data?.mystage_token,
    };
  },
  handleFetch: () => {
    tokenInvalid = false;
  },
  handleError: (err) => {
    logger.error(`[MYSTAGE][AUTH] Unable to refresh: ${err.message}`, {
        operation: "mystage_refresh_token",
        mystage_token: getMyStageToken()
    });
  },
});

const errorLink = onError(({ networkError, operation, forward }) => {
  if (networkError && networkError.statusCode === 401) {
    tokenInvalid = true;
    return forward(operation);
  }
});

export default from([errorLink, refreshLink]);
